import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Footer from "../inc/Footer";
import { path } from "../../../utils";
import "./ProductWarranty.scss";
import Header from "../inc/Header";
class ProductWarranty extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let { language } = this.props;
    return (
      <>
        <Header />
        {language === "vi" ? (
          <div className="container product-warranty">
            <div className="intro">
              <h2>CHÍNH SÁCH & ĐIỀU KHOẢN DỊCH VỤ</h2>
              <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối chính thức thiết bị phân
                tích cơ thể Anovator A5
              </p>
            </div>
            <h2>MỤC 5 - CHÍNH SÁCH BẢO HÀNH SẢN PHẨM</h2>
            <p>
              🛡️ <strong>Cam kết bảo hành chính hãng – An tâm sử dụng</strong>
            </p>
            <p>
              Chúng tôi cung cấp chính sách bảo hành minh bạch, hỗ trợ kỹ thuật
              tận tình để đảm bảo trải nghiệm sử dụng sản phẩm Anovator A5 của
              bạn luôn hiệu quả và bền lâu.
            </p>

            <h4>⏳ Thời gian bảo hành:</h4>
            <ul>
              <li>
                Thiết bị chính (Anovator A5): 12 tháng kể từ ngày giao hàng
              </li>
              <li>
                Phụ kiện đi kèm: 6 tháng hoặc theo thông báo riêng tùy từng loại
              </li>
              <li>
                <em>
                  *Thời hạn bảo hành được xác nhận dựa trên hóa đơn bán hàng
                  hoặc mã đơn hàng trong hệ thống.*
                </em>
              </li>
            </ul>

            <h4>✅ Điều kiện được bảo hành:</h4>
            <ul>
              <li>Sản phẩm còn trong thời hạn bảo hành</li>
              <li>
                Không có dấu hiệu bị can thiệp trái phép hoặc hư hỏng do người
                dùng gây ra
              </li>
              <li>
                Có hóa đơn/phiếu bảo hành hoặc thông tin xác minh từ hệ thống
                Anovator Việt Nam
              </li>
            </ul>

            <h4>❌ Các trường hợp không áp dụng bảo hành:</h4>
            <ul>
              <li>
                Hư hỏng do va đập, rơi vỡ, thấm nước, cháy nổ hoặc tác động bên
                ngoài
              </li>
              <li>Tự ý tháo lắp, sửa chữa bởi đơn vị không được ủy quyền</li>
              <li>
                Sử dụng sai hướng dẫn, không đúng nguồn điện hoặc môi trường yêu
                cầu
              </li>
              <li>Sản phẩm không được mua từ hệ thống phân phối chính thức</li>
            </ul>

            <h4>🔄 Quy trình bảo hành:</h4>
            <ol>
              <li>Liên hệ hotline hoặc email trung tâm hỗ trợ kỹ thuật</li>
              <li>Cung cấp thông tin đơn hàng, số serial máy, mô tả lỗi</li>
              <li>
                Gửi sản phẩm về trung tâm kỹ thuật hoặc địa chỉ được hướng dẫn
              </li>
              <li>Kiểm tra & xử lý trong vòng 3–7 ngày làm việc</li>
              <li>Giao trả sản phẩm sau khi sửa chữa hoặc thay thế</li>
            </ol>

            <h4>🧰 Dịch vụ kỹ thuật & hỗ trợ sau bảo hành:</h4>
            <ul>
              <li>
                Nếu sản phẩm hết hạn bảo hành, bạn vẫn được hỗ trợ sửa chữa với
                mức phí ưu đãi
              </li>
              <li>Các linh kiện thay thế được đảm bảo chính hãng 100%</li>
              <li>
                Trung tâm kỹ thuật hỗ trợ trực tiếp tại TP.HCM và Hà Nội, hoặc
                gửi chuyển phát nhanh toàn quốc
              </li>
            </ul>

            <h4>🏢 Trung tâm bảo hành – Anovator Việt Nam:</h4>
            <ul>
              <li>
                <strong>Email hỗ trợ:</strong> support@anovator.vn
              </li>
              <li>
                <strong>Giờ làm việc:</strong> 8h – 17h từ thứ 2 đến thứ 7 (trừ
                lễ, Tết)
              </li>
            </ul>
            <div className="contact-info support">
              <h2>THÔNG TIN LIÊN HỆ HỖ TRỢ</h2>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối Anovator chính thức tại
                Việt Nam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Điện thoại:</strong> 0359.951.5131 (Phước)
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Văn Phòng Chính - Top Fitness Center:</strong>
                <br />
                227 - 229 Hà Huy Giáp, Phường Thạnh Lộc, Quận 12
              </p>
            </div>
          </div>
        ) : (
          <div className="container product-warranty">
            <div className="intro">
              <h2>POLICIES & TERMS OF SERVICE</h2>
              <p>Applicable to all customers in Vietnam</p>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator A5 Body
                Composition Analyzer
              </p>
            </div>
            <h2>SECTION 5 - PRODUCT WARRANTY POLICY</h2>
            <p>
              🛡️ <strong>Official Warranty - Confident Use Guaranteed</strong>
            </p>
            <p>
              We provide a transparent warranty policy and dedicated technical
              support to ensure your experience with the Anovator A5 remains
              effective and long-lasting.
            </p>

            <h4>⏳ Warranty Period:</h4>
            <ul>
              <li>
                Main device (Anovator A5): 12 months from the delivery date
              </li>
              <li>Accessories: 6 months or based on individual item notice</li>
              <li>
                <em>
                  *Warranty period is validated based on the sales invoice or
                  order ID in our system.*
                </em>
              </li>
            </ul>

            <h4>✅ Warranty Conditions:</h4>
            <ul>
              <li>The product is still within the warranty period</li>
              <li>
                No signs of unauthorized tampering or user-inflicted damage
              </li>
              <li>
                Valid invoice/warranty card or verifiable information from the
                Anovator Vietnam system
              </li>
            </ul>

            <h4>❌ Warranty Exclusions:</h4>
            <ul>
              <li>
                Damage caused by impact, drops, water exposure, fire, or
                external forces
              </li>
              <li>
                Unauthorized disassembly or repair by unapproved service
                providers
              </li>
              <li>
                Improper usage, incorrect power supply, or unsuitable operating
                environment
              </li>
              <li>
                Product not purchased through official distribution channels
              </li>
            </ul>

            <h4>🔄 Warranty Process:</h4>
            <ol>
              <li>Contact our technical support via hotline or email</li>
              <li>
                Provide order information, device serial number, and issue
                description
              </li>
              <li>
                Send the product to the designated service center or provided
                address
              </li>
              <li>Inspection & resolution within 3-7 business days</li>
              <li>Product returned after repair or replacement</li>
            </ol>

            <h4>🧰 Post-Warranty Support Services:</h4>
            <ul>
              <li>
                If the product is out of warranty, repair services are still
                available at a preferential fee
              </li>
              <li>All replacement parts are guaranteed 100% genuine</li>
              <li>
                Technical support is available in Ho Chi Minh City and Hanoi, or
                via nationwide shipping
              </li>
            </ul>

            <h4>🏢 Warranty Center - Anovator Vietnam:</h4>
            <ul>
              <li>
                <strong>Support Email:</strong> support@anovator.vn
              </li>
              <li>
                <strong>Working Hours:</strong> 8:00 AM - 5:00 PM, Monday to
                Saturday (excluding holidays)
              </li>
            </ul>
            <div className="contact-info support">
              <h2>SUPPORT CONTACT INFORMATION</h2>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator in Vietnam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Phone:</strong> 0989.499.889
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Head Office - Top Fitness Center:</strong>
                <br />
                227 - 229 Ha Huy Giap Street, Thanh Loc Ward, District 12
              </p>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductWarranty),
);
